//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('powTimePayCheckLs', {
//        templateUrl: 'views/components/views/powTimePayCheckLs/powTimePayCheckLs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'powTimePayCheckLsService', 'ttGridFactory', 'layoutService', function ($stateParams, powTimePayCheckLsService, ttGridFactory, layoutService) {

//    		// #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let desktopSize = layoutService.getMediaQueries().desktop;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                desktopSize: desktopSize,
//                itemsListPayCheckLs: [],
//                gridReady: false
//    		};

//            vm.grid = new ttGridFactory({
//                rememberId: 'powtimepaycheckls_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//    		// #region LOAD PROCEDURE CALL

//            async function loadPayCheckLs() {
//                vm.model.itemsListPayCheckLs = await powTimePayCheckLsService.listPayCheckLs({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE CALL

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3507,
//                    parameters: {
//                        argtype: argType,
//                        argvalue: argValue
//                    }
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadPayCheckLs();
//                loadGrid();
//            }

//            // #endregion ON INIT FUNCTION

//    	}]
//    });
//})();
